import { useQuery } from 'react-apollo'
import { ListConfigs } from '../../../graphql/configs/queries'

export const useQueryListRaceApi = () => {
  const {
    data: raceListData,
    error: raceListError,
    loading: raceListLoading,
  } = useQuery(ListConfigs, {
    variables: {
      sort: {
        name: 'asc',
      },
      limit: 500,
      page: 1,
      filter: {
        domain: 'MASTERDATA',
        category: 'RACE',
      },
    },
  })

  return {
    data: raceListData?.listConfigs?.configs,
    error: raceListError,
    loading: raceListLoading,
  }
}
